import Vuex from 'vuex'
import getters from './getters.js'
import app from './app'


const store = new Vuex.Store({
  modules: {
    app
  },
  getters
})

export default store
